import { render, staticRenderFns } from "./FactorItem.vue?vue&type=template&id=e2c810ea&"
import script from "./FactorItem.vue?vue&type=script&lang=js&"
export * from "./FactorItem.vue?vue&type=script&lang=js&"
import style0 from "./FactorItem.vue?vue&type=style&index=0&id=e2c810ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports